<script lang="ts">
import BaseLabel from '@/components/globals/BaseLabel.vue'
import { Component } from 'vue-property-decorator'

@Component({})
export default class CancelledStatusLabel extends BaseLabel {
  protected color = 'is-danger'
}
</script>
